import React, { useState } from "react";

import AdvancedSearchTopics from "./AdvancedSearchTopics";
import ArchiveWrapper from "../../common/archive/ArchiveWrapper";
import { SonicTopicsData } from "../../common/classes/SonicTopics";
import PageHelperModal from "../../common/page-help/PageHelperModal";
import PageTitle from "../../common/PageTitle";
import TopicsListItem from "../top/topics/TopicsListItem";

import { getLargestImage, timestampToTime } from "../../utils/GeneralUtils";
import { PageTypes } from "../../utils/PageTypes";
import { SearchParam } from "../../common/archive/ListSearchFunc";
import { SonicTermData } from "../../common/classes/SonicTerm";

type Props = {
  isLoading: boolean;
  sorted_topics: Array<SonicTopicsData>;
  totalEntries: number;
  totalPages: number;
  currentPage: number;
  perView: number;
  keywordParam?: string;
  gameOptions: Array<SonicTermData>;
  gameParams: Array<string>;
  typeOptions: Array<SonicTermData>;
  typeParams: Array<string>;
  searchHandler: (params: Array<SearchParam>) => void;
  clearSearch: () => void;
  handlePerView: (value: number) => void;
};
const TopicsDB: React.FC<Props> = ({
  isLoading,
  sorted_topics,
  totalEntries,
  totalPages,
  currentPage,
  perView,
  keywordParam,
  gameOptions,
  gameParams,
  typeOptions,
  typeParams,
  searchHandler,
  clearSearch,
  handlePerView,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleHelpModal = () => {
    setShowModal(!showModal);
  };

  return (
    <main>
      <PageTitle
        title={"TOPICS"}
        subtext={"トピックス"}
        handleHelpModal={handleHelpModal}
      />
      <ArchiveWrapper
        title={"トピックス一覧"}
        hasResults={sorted_topics.length == 0 ? false : true}
        isLoading={isLoading}
        currentPage={currentPage}
        perView={perView}
        totalEntries={totalEntries}
        totalPages={totalPages}
        handlePerView={handlePerView}
        searchComponent={
          <AdvancedSearchTopics
            keywordParam={keywordParam ? keywordParam : ""}
            gameOptions={gameOptions}
            gameParams={gameParams}
            typeOptions={typeOptions}
            typeParams={typeParams}
            clearSearch={clearSearch}
            searchHandler={searchHandler}
          />
        }
        type={PageTypes.Topics}
      >
        {sorted_topics?.map((topic, i: number) => (
          <TopicsListItem
            to={topic.id}
            key={i}
            category={topic.topic_type?.name}
            date={timestampToTime(topic.start_date, false, false, ".")}
            title={topic.name}
            author={topic.author_name}
            img_src={getLargestImage(topic.imgs?.[0])}
            tags={topic.tags}
          />
        ))}
      </ArchiveWrapper>
      {showModal && (
        <PageHelperModal
          handleHelpModal={handleHelpModal}
          helpTitle="トピックスとは？"
          helpText={
            "eスポーツ関連の記事が掲載されています。\nSELeCT会員による執筆記事も掲載されています。"
          }
        />
      )}
    </main>
  );
};

export default TopicsDB;
